export const modalBodyStyle = {
  background: '#F8F8F8',
  height: '550px',
  padding: '0',
};
